import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const EmpresaContext = createContext(null);
const KEY = "empresa_atual_id";

export function EmpresaProvider({ children }) {
  const { user } = useAuth();
  const [empresas, setEmpresas] = useState([]);
  const [empresaAtualId, setEmpresaAtualIdState] = useState(() => localStorage.getItem(KEY) || "");
  const [loading, setLoading] = useState(true);

  const carregarEmpresas = useCallback(async () => {
    if (!user) { setEmpresas([]); setLoading(false); return; }
    try {
      const { data } = await api.get("/empresas");
      setEmpresas(data);
      const salvo = localStorage.getItem(KEY);
      const validos = data.filter((e) => e.ativa !== false).map((e) => e.id);
      if (!salvo || !validos.includes(salvo)) {
        const primeira = validos[0] || "";
        if (primeira) {
          localStorage.setItem(KEY, primeira);
          setEmpresaAtualIdState(primeira);
        } else {
          localStorage.removeItem(KEY);
          setEmpresaAtualIdState("");
        }
      }
    } catch (e) {
      console.error("EmpresaContext carregarEmpresas:", e?.message);
    } finally {
      setLoading(false);
    }
  }, [user]);

  // Recarrega toda vez que o usuário logar/deslogar
  useEffect(() => { carregarEmpresas(); }, [carregarEmpresas]);

  const selecionar = (id) => {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
    setEmpresaAtualIdState(id || "");
  };

  const empresaAtual = useMemo(
    () => empresas.find((e) => e.id === empresaAtualId) || null,
    [empresas, empresaAtualId]
  );

  // v9.79 (code review): memoiza value pra não re-renderizar consumers.
  const value = useMemo(
    () => ({
      empresas, empresaAtual, empresaAtualId, selecionar,
      recarregar: carregarEmpresas, loading,
    }),
    [empresas, empresaAtual, empresaAtualId, carregarEmpresas, loading]
  );

  return (
    <EmpresaContext.Provider value={value}>
      {children}
    </EmpresaContext.Provider>
  );
}

export const useEmpresa = () => useContext(EmpresaContext);
